export default "__VITE_ASSET__B9CSB3Us__"